<template>
  <a-modal
    title="操作"
    width="80%"
    :visible="visible"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :form="form">
      <a-form-item
        label="数据图编号"
        :labelCol="{lg: {span: 2}, sm: {span: 7}}"
        :wrapperCol="{lg: {span: 12}, sm: {span: 10} }"
      >
        <span style="margin-left:10px">{{ `${data_id}` }}</span>
      </a-form-item>

      <a-form-item style="overflow:auto">
        <s-table
          size="small"
          :columns="columns"
          :data="loadData"
          @deleteUser="reloadData"
          ref="datatable"
        >
          <span slot="action" slot-scope="text, record">
            <a-tag size="small" v-if="canAdd(record.id) && (record.origin_data.task_status==1 ||record.origin_data.task_status==2)" @click="handleDetails(record,'add')" >添加</a-tag>
            <a-tag size="small" color="orange" v-if="canAdd(record.id)==false && (record.origin_data.task_status==1 ||record.origin_data.task_status==2)" @click="handleDetails(record,'remove')">移除</a-tag>
            <a-tag size="small" color="pink" v-if="record.origin_data.task_status==1" @click="handleConfirm(record)">确认</a-tag>
            <a-tag size="small" color="green" v-if="record.origin_data.task_status==2" >完成</a-tag>
            <a-tag size="small" color="red" @click="handleDelete(record)">删除</a-tag>
          </span>
          <span slot="avatar" slot-scope="user_avatar">
            <a-avatar :src="user_avatar"/>
          </span>
          <span slot="task_status" slot-scope="text, record">
            <a-steps :current="record.task_status_num" status="process" size="small">
              <a-step title="分配" />
              <a-step title="标注" />
              <a-step title="确认" />
            </a-steps>
          </span>
        </s-table>
      </a-form-item>
      <details-modal ref="details" v-if="visible"></details-modal>
    </a-form>
  </a-modal>
</template>

<script>
import { getTaskUserList } from '@/api/data'
import { confirmTask, deleteTask } from '@/api/task'

import STable from '@/components/table/'
import DetailsModal from './DetailsModal'
import { getTaskStatusText } from '@/utils/const'
export default {
  name: 'ArrangeMemberListModal',
  components: {
    STable,
    DetailsModal
  },
  data () {
    return {
      data_id: '',
      showList: [],
      list: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      visible: false,
      columns: [
        {
          title: '编号',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '头像',
          dataIndex: 'user_avatar',
          key: 'user_avatar',
          scopedSlots: { customRender: 'avatar' }
        },
        {
          title: '姓名',
          dataIndex: 'user_name',
          key: 'user_name'
        },
        {
          title: '手机号',
          dataIndex: 'user_mobile',
          key: 'user_mobile'
        },
        {
          title: '标注状态',
          dataIndex: 'task_status',
          key: 'task_status',
          scopedSlots: { customRender: 'task_status' }
        },
        {
          title: '分配时间',
          dataIndex: 'create_time',
          key: 'create_time'
        },
        {
          title: '最后更新',
          dataIndex: 'update_time',
          key: 'update_time'
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          width: 300,
          scopedSlots: { customRender: 'action' }
        }
      ],
      loadData: this.dataHandle
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    add (data) {
      this.data_id = data.data_id
      this.showList = []
      this.visible = true
      const _this = this

      this.$nextTick(() => {
        _this.reloadData()
      })
    },
    handleDetails (record, action) {
      this.tangleAdd(record.id)
      if (action == 'add') this.$refs.details.add(record.origin_data)
      if (action == 'remove') this.$refs.details.remove(record.origin_data)
    },
    handleConfirm (record) {
      const task_id = record.origin_data.id
      const _this = this
      confirmTask({ task_id: task_id }).then(() => {
        _this.$message.success('确认成功')
        _this.reloadData()
      }).catch(() => {
        _this.$message.error('确认失败')
      })
    },
    handleDelete (record) {
      const _this = this
      _this.$confirm({
        title: '移除标注用户',
        content: '真的要取消用户“' + record.user_name + '”的标注任务吗？',
        onOk () {
          return new Promise((resolve, reject) => {
            deleteTask(record.origin_data.id).then(res => {
              _this.$message.success('取消成功')
              resolve()
            }).catch(() => {
              _this.$message.error('取消失败')
              reject()
            }).finally(() => {
              _this.reloadData()
            })
          })
        },
        onCancel () {}
      })
    },
    canAdd (id) {
      for (var i = 0; i < this.showList.length; i++) {
        if (this.showList[i].id == id) return this.showList[i].canAdd
      }
    },
    tangleAdd (id) {
      for (var i = 0; i < this.showList.length; i++) {
        if (this.showList[i].id == id) {
          this.showList[i].canAdd = !this.showList[i].canAdd
        }
      }
    },
    handleOk () {
      this.$emit('dataChanged')
      this.visible = false
    },
    handleCancel () {
      this.visible = false
    },
    reloadData () {
      this.$refs.datatable.refresh(true)
    },
    dataHandle () {
      const data_id = this.data_id
      const _this = this
      return new Promise(resolve => {
        getTaskUserList({ data_id: data_id }).then(res => {
          var id = 1
          var list = []
          res.data.map(item => {
            list.push({
              id: id,
              user_avatar: item.user.user_avatar,
              user_name: item.user.user_name,
              user_mobile: item.user.user_mobile,
              task_status_num: item.task_status,
              create_time: item.create_time,
              update_time: item.update_time,
              origin_data: item
            })
            _this.showList.push({
              id: id,
              canAdd: true
            })
            id++
          })
          if (list.length == 0) {
            _this.$refs.datatable.localLoading = false
            resolve({ data: [] })
          }
          resolve({ data: list })
        })
      })
    }

  }
}
</script>
